
import settingsManager from 'core/managers/settings';
export const userSecurityGroups = () => {
  return settingsManager.get('user').securityGroups || [];
};